<template>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <h3>Cadastro de leads</h3>
        <div class="dropdown-divider"></div>
        <h5>Aqui será feito a importação dos leads</h5>
        <div class="form-group row">
          <div class="col-lg-4">
            <label>&nbsp;</label>
            <input type="file" ref="file-to-upload" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
          </div>
          <div class="col-lg-4">
            <input type="checkbox" v-model="useServerFile"> Usar arquivo do servidor <br />
            <input type="text" class="form-control" placeholder="Nome do arquivo" v-model="caminho">
          </div>
          <div class="col-lg-4">
            <label>Separador</label>
            <input type="text" class="form-control" placeholder="separador" v-model="separador">
          </div>
          <div class="col-lg-12">
            <input type="button" v-on:click="map" value="Mapear" class="btn btn-primary mr-2">
          </div>
        </div>
      </div>
      <table class="table">
        <tr v-bind:key="rowKey" v-for="(item, rowKey) in fileColumns">
          <td> {{ item.name }}</td>
          <td>
            <select class="form-control-sm" v-model="item.selectedOption" @change="filterOptions">
              <option value=""> - Ignorar - </option>
              <option v-for="option in item.filteredOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
            </select>
          </td>
        </tr>
        <tr v-if="allowSubmit">
          <td colspan="2">
            <input type="button" v-on:click="upload" :value="textButton" class="btn btn-primary mr-2">
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {H, showInfo} from 'hennig-common'
import {showError} from 'hennig-common/src/lib/notifications'

export default {
  name: 'CrmLeadImport',
  data () {
    return {
      current: '',
      tmpContent: '',
      textButton: 'Enviar',
      separador: ',',
      options: [
        {
          value: 'data_cancelamento',
          label: 'Contrato :: Data Cancelamento',
        },
        {
          value: 'data_contratacao',
          label: 'Contrato :: Data Contratação',
        },
        {
          value: 'produto_contratado',
          label: 'Contrato :: Produto Contratado',
        },
        {
          value: 'status_contrato',
          label: 'Contrato :: Status',
        },
        {
          value: 'email_disparo',
          label: 'Email :: Principal',
        },
        {
          value: 'capital_social',
          label: 'Empresa :: Capital Social',
        },
        {
          value: 'perfil_cliente',
          label: 'Empresa :: Categoria/Tipo/Tamanho',
        },
        {
          value: 'cnae_lead',
          label: 'Empresa :: CNAE Principal',
        },
        {
          value: 'descricao_cnae_lead',
          label: 'Empresa :: CNAE Principal Descrição',
        },
        {
          value: 'cnaes_secundarios',
          label: 'Empresa :: CNAE Secundário',
        },
        {
          value: 'nome_fantasia',
          label: 'Empresa :: Nome Fantasia',
        },
        {
          value: 'razao_social',
          label: 'Empresa :: Razão Social',
        },
        {
          value: 'base_envio',
          label: 'Geral :: Base de Envio',
        },
        {
          value: 'doc_cliente',
          label: 'Geral :: CPF/CNPJ',
        },
        {
          value: 'data_nascimento',
          label: 'Geral :: Data Nascimento/Fundação',
        },
        {
          value: 'local_aquisicao',
          label: 'Geral :: Onde o Lead Foi Captado',
        },
        {
          value: 'bairro',
          label: 'Endereço :: Bairro',
        },
        {
          value: 'cep',
          label: 'Endereço :: CEP',
        },
        {
          value: 'cidade',
          label: 'Endereço :: Cidade',
        },
        {
          value: 'complemento_endereco',
          label: 'Endereço :: Complemento',
        },
        {
          value: 'endereco',
          label: 'Endereço :: Endereço',
        },
        {
          value: 'numero_endereco',
          label: 'Endereço :: Nº',
        },
        {
          value: 'uf',
          label: 'Endereço :: UF',
        },
        {
          value: 'tipo_cliente',
          label: 'Geral :: Tipo de Cliente',
        },
        {
          value: 'contato_email',
          label: 'Pessoa :: Nome do Contato',
        },
        {
          value: 'sexo',
          label: 'Pessoa :: Sexo',
        },
        {
          value: 'telefone_celular',
          label: 'Telefone :: Celular',
        },
        {
          value: 'telefone_comercial',
          label: 'Telefone :: Comercial',
        },
        {
          value: 'ddd_contato',
          label: 'Telefone :: DDD',
        },
        {
          value: 'telefone_residencial',
          label: 'Telefone :: Residencial',
        },
        {
          value: 'contato_whatsapp',
          label: 'Telefone :: Whatsapp',
        }
      ],
      fileColumns: [],
      mappedColumns: [],
      allowSubmit: false,
      useServerFile: false,
      caminho: ''
    }
  },
  watch: {
    current () {
      if (this.current === '') {
        return
      }

      this.fileColumns.forEach((num, idx, arr) => {
        let tmp = {
          label: num.selectedOption,
          value: idx
        }

        this.mappedColumns.push(tmp)
      })

      H.rpc('CrmLead', 'crmUpload', [{file: this.current, columns: this.mappedColumns, caminho: this.caminho, separador: this.separador}], (rows) => {
        showInfo('Importação agendada! Você será notificado ao final do processo.')
        this.textButton = 'Enviar'
      })

      this.current = ''
    },
    fileColumns: {
      handler (val) {
        let docCli = val.some(item => item.selectedOption === 'doc_cliente')
        let email = val.some(item => item.selectedOption === 'email_disparo')

        this.allowSubmit = docCli && email
      },
      deep: true,
    }
  },
  methods: {
    filterOptions () {
      const selectedOptions = this.fileColumns.map(select => select.selectedOption)
      this.fileColumns.forEach(select => {
        select.filteredOptions = this.options.filter(option => !selectedOptions.includes(option.value) || option.value === select.selectedOption)
      })
    },
    async map () {
      this.fileColumns = []
      this.current = ''
      this.tmpContent = ''
      this.textButton = 'Enviar'
      this.fileColumns = []
      this.mappedColumns = []
      this.allowSubmit = false

      let aFiles = this.$refs['file-to-upload'].files

      if (aFiles.length === 0) {
        showError('Nenhum arquivo selecionado')
        return
      }

      const readHeader = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => {
            const text = reader.result
            const lines = text.split('\n')
            const headers = lines[0].split(this.separador)

            headers.forEach(header => {
              if (header.trim() !== '') {
                let data = {
                  name: header,
                  selectedOption: null,
                  filteredOptions: []
                }
                this.fileColumns.push(data)
              }
            })

            resolve(reader.result)
          }
          reader.onerror = reject
          reader.readAsText(file)
        })
      }

      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => {
            resolve(reader.result)
          }
          reader.onerror = reject
          reader.readAsDataURL(file)
        })
      }

      try {
        for (const file of aFiles) {
          await readHeader(file)
          this.tmpContent = await readFile(file)
        }

        this.fileColumns.forEach(select => {
          select.filteredOptions = [...this.options]
        })

      } catch (error) {
        showError('Erro ao processar o arquivo')
        this.textButton = 'Enviar'
      }
    },
    async upload () {
      if (this.useServerFile && (this.caminho === '' || this.caminho === null)) {
        showError('Arquivo não informado')
        return
      }

      this.textButton = 'Enviando... aguarde'
      this.current = this.tmpContent
    }
  }
}
</script>

<style scoped>

</style>
